export enum GridOption  {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  CLONE = 'CLONE',
}
